module.exports = __webpack_public_path__ + "static/assets/4e756888929288ec5a9bf4d027f28aa1.png";